import ComponentWithSocket from '../../../lib/component'
import { Component } from 'vue-property-decorator';

import * as Store from '../../../store';

import template from './manage.vue';
import moment from 'moment';

import WebsocketClient, { WebsocketsListener } from '../../../utils/ws';

@Component({
    mixins: [template]
})

export default class ManageUser extends ComponentWithSocket {

    private data: {
        id: string,
        user: any,
        address: any
    } = {
        id: '',
        user: undefined,
        address: {
            city: '',
            street: '',
            country: '',
            county: ''
        }
    };

    activeTabIndex: number = 0

    constructor() {

        super();

        this.wsListener.onGet('admin.users.view', (success: boolean, data: any) => {

            Store.commitLoaderVisibility(this.$store, false);

            if (success) {
                this.data.user = data;

                if (data.address) {
                    this.data.address = data.address
                }
            }

        });

        this.wsListener.onPost('admin.users.update', (success: boolean, data: any) => {
            if (success) {
                Store.commitLoaderVisibility(this.$store, false);
            }
        });
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from)
        next()
    }

    mounted() {

        this.data.id = this.$root.$route.params.id;

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('admin.users.view', {
            _id: this.data.id
        });
    }

    doUserUpdate() {

        Store.commitLoaderVisibility(this.$store, true);

        let updatedUser = this.data.user
        updatedUser.address = this.data.address

        this.wsListener.sendPost('admin.users.update', updatedUser)
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/users/manage/index.ts